import styled from 'styled-components'

export const Container = styled.header`
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;

  /* Volta para o fluxo normal da página */
  background: ${(props) => props.theme.azulPrincipal};
  z-index: 10;
`

export const Logo = styled.img`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 55px;
`
